const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    location: 'United Kingdom',
    rating: 5,
    text: 'Absolutely incredible experience! Dario made me feel safe and comfortable from start to finish. The views were breathtaking and I can\'t wait to fly again!',
    image: 'https://public.readdy.ai/ai/img_res/0c99f67f90a8b88bd3984d939745a263.jpg'
  },
  {
    id: 2,
    name: 'Marco Rossi',
    location: 'Italy',
    rating: 5,
    text: 'Best adventure of my life! Dario is a true professional with amazing skills. The thermal flight was spectacular and the photos are stunning. Highly recommended!',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20smiling%20man%20with%20dark%20hair%2C%20friendly%20confident%20expression%2C%20outdoor%20natural%20lighting%2C%20casual%20adventure%20style%2C%20simple%20clean%20background&width=200&height=200&seq=testimonial-marco&orientation=squarish'
  },
  {
    id: 3,
    name: 'Emma Johnson',
    location: 'USA',
    rating: 5,
    text: 'I was nervous at first, but Dario\'s calm demeanor and expertise put me at ease immediately. The sunset flight was magical - a memory I\'ll treasure forever!',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20cheerful%20woman%20with%20brown%20hair%2C%20warm%20smile%2C%20outdoor%20natural%20lighting%2C%20friendly%20approachable%20look%2C%20simple%20clean%20background&width=200&height=200&seq=testimonial-emma&orientation=squarish'
  },
  {
    id: 4,
    name: 'Thomas Weber',
    location: 'Germany',
    rating: 5,
    text: 'The acrobatic flight was pure adrenaline! Dario knows exactly what he\'s doing. Safety first, but also maximum fun. An unforgettable experience!',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20athletic%20man%20with%20short%20hair%2C%20confident%20smile%2C%20outdoor%20natural%20lighting%2C%20adventurous%20personality%2C%20simple%20clean%20background&width=200&height=200&seq=testimonial-thomas&orientation=squarish'
  },
  {
    id: 5,
    name: 'Sophie Laurent',
    location: 'France',
    rating: 5,
    text: 'Perfect from beginning to end! The equipment is top quality, Dario is incredibly professional, and the whole experience exceeded my expectations. Thank you!',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20elegant%20woman%20with%20long%20dark%20hair%2C%20genuine%20smile%2C%20outdoor%20natural%20lighting%2C%20sophisticated%20friendly%20look%2C%20simple%20clean%20background&width=200&height=200&seq=testimonial-sophie&orientation=squarish'
  },
  {
    id: 6,
    name: 'James Anderson',
    location: 'Australia',
    rating: 5,
    text: 'Bucket list item checked! Flying with Dario was the highlight of my trip. Professional, friendly, and the views were absolutely stunning. 10/10 would recommend!',
    image: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20smiling%20man%20with%20light%20hair%2C%20relaxed%20friendly%20expression%2C%20outdoor%20natural%20lighting%2C%20casual%20adventure%20style%2C%20simple%20clean%20background&width=200&height=200&seq=testimonial-james&orientation=squarish'
  }
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-sky-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Flyers Say
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it - hear from those who've experienced the thrill
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow"
            >
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </div>
              
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              
              <p className="text-gray-700 leading-relaxed italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center bg-sky-100 rounded-full px-8 py-4">
            <i className="ri-star-fill text-yellow-400 text-2xl mr-3"></i>
            <div className="text-left">
              <p className="text-3xl font-bold text-gray-900">5.0</p>
              <p className="text-sm text-gray-600">Average Rating</p>
            </div>
            <div className="ml-8 text-left">
              <p className="text-3xl font-bold text-gray-900">2000+</p>
              <p className="text-sm text-gray-600">Happy Customers</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
